import styled, { css } from 'styled-components';

export const ModalContentContainer = styled.div`
  align-items: center;
  text-align: center;
  padding-top: 30px;
`;

export const CloseIconWrapper = styled.div<{
  direction: 'ltr' | 'rtl';
}>`
  position: absolute;

  ${props =>
    props.direction === 'rtl'
      ? css`
          left: 15px;
          top: 15px;

          cursor: pointer;

          @media only screen and (max-width: 640px) {
            left: 5px;
            top: 5px;
          }
        `
      : css`
          right: 15px;
          top: 15px;

          cursor: pointer;

          @media only screen and (max-width: 640px) {
            right: 5px;
            top: 5px;
          }
        `}
`;

export const ButtonWrapper = styled.div`
  padding: 20px 0;
  [class*='CloseButtonstyle__CloseButton-sc'] {
    right: 200px !important;
  }
`;

export const FooterWrapper = styled.div`
  font-size: 14px;

  a {
    text-decoration: underline;
  }
`;
